import styled from '@emotion/styled';
import { Link } from 'react-router';
import { ContentWidget } from '../../../widgets/ContentWidget';
import { FeatureNodeType } from '../../../data/features';

export namespace S {
  export const Steps = styled.ol`
    list-style: none;
    padding: 0;
    margin: 0 0 24px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 24px;
    color: ${(p) => p.theme.text.paragraph};
    font-size: 13px;
    button {
      background: none;
      border: 0;
      padding: 4px 0;
      color: inherit;
      font: inherit;
      cursor: pointer;
      &:hover:not(:disabled) {
        color: ${(p) => p.theme.text.special};
        text-decoration: underline;
      }
      &:focus-visible {
        outline: 2px solid ${(p) => p.theme.text.special};
        outline-offset: 4px;
        border-radius: 2px;
      }
      &:disabled {
        cursor: default;
        opacity: 0.5;
      }
    }
    [aria-current='step'] {
      color: ${(p) => p.theme.text.special};
      font-weight: 600;
    }
  `;
  export const StepHeading = styled.h2`
    color: ${(p) => p.theme.text.heading};
    font-size: 22px;
    margin: 0 0 16px;
    &:focus {
      outline: none;
    }
  `;
  export const Actions = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 24px;
    margin-top: 20px;
    a {
      color: ${(p) => p.theme.text.special};
    }
  `;
  export const Next = styled.button`
    background: ${(p) => p.theme.card.hoverBackground};
    color: ${(p) => p.theme.text.heading};
    border: 1px solid ${(p) => p.theme.text.special};
    border-radius: 8px;
    padding: 10px 16px;
    font: inherit;
    font-size: 14px;
    cursor: pointer;
    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }
  `;

  export const Edit = styled(Next.withComponent(Link))`
    text-decoration: none;
    flex-shrink: 0;
  `;
  export const ResultHeading = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
    h2 {
      margin: 0;
    }
  `;
  export const Selections = styled.dl`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    font-size: 14px;
  `;
  export const SelectionRow = styled.div`
    display: grid;
    grid-template-columns: 100px minmax(0, 1fr);
    align-items: baseline;
    gap: 12px;
    dt {
      color: ${(p) => p.theme.text.paragraph};
    }
    dd {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin: 0;
    }
    @media (max-width: 500px) {
      grid-template-columns: minmax(0, 1fr);
      gap: 6px;
    }
  `;
  export const SelectionValue = styled.span`
    padding: 5px 10px;
    border-radius: 6px;
    background: ${(p) => p.theme.card.hoverBackground};
    color: ${(p) => p.theme.text.heading};
    line-height: 1.5;
  `;
  export const Unselected = styled.span`
    color: ${(p) => p.theme.text.paragraph};
    padding: 5px 0;
  `;

  export const Legend = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 24px 0;
  `;
  export const Connections = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 24px;
  `;
  export const ConnectionRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 12px;
    > span {
      color: ${(p) => p.theme.text.paragraph};
    }
  `;
  export const Connection = styled.a<{ nodeType: FeatureNodeType }>`
    color: ${(p) => p.theme.featureGraph[p.nodeType].accent};
    border: 1px solid ${(p) => p.theme.featureGraph[p.nodeType].border};
    border-radius: 6px;
    padding: 5px 9px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  `;

  export const Intro = styled(ContentWidget)`
    margin-bottom: 28px;
    p {
      max-width: 800px;
    }
    > a {
      display: inline-block;
      margin-top: 20px;
    }
  `;
  export const Explorer = styled.div`
    padding: 24px;
    border: 1px solid ${(p) => p.theme.surface.border};
    border-radius: 20px;
    background: ${(p) => p.theme.surface.background};
  `;
  export const Goals = styled.fieldset`
    border: 0;
    margin: 0;
    padding: 0;
    min-width: 0;
    & + & {
      margin-top: 20px;
    }
    legend {
      color: ${(p) => p.theme.text.heading};
      font-weight: 600;
      padding: 0 0 10px;
    }
  `;
  export const GoalGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  `;
  export const Filters = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 24px;
    > :first-child {
      flex: 1 1 300px;
    }
  `;
  export const Reset = styled.button`
    color: ${(p) => p.theme.text.special};
    background: none;
    border: none;
    padding: 8px 0;
    font: inherit;
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;
  `;
  export const Items = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
  `;
  export const Empty = styled.p`
    color: ${(p) => p.theme.text.paragraph};
    padding: 24px 0;
  `;
}
